import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import LogOut from "./Logout";

const NETWORK_LINKS = [
    ["All sites", "https://pfffnet.work/"],
    ["Adult Telegram", "https://telegramadult.com/"],
    ["Juicy Elf", "https://juicyelf.com/"],
    ["Fap Tracker", "https://eroyn.com/"],
    ["Our blog", "https://noshitblog.com/"],
    ["Sex stories", "https://textmesex.com/"],
    ["Kill 5 Minutes", "https://kill5minutes.com/"]
];

const Header = styled.header`
    position: sticky;
    top: 0;
    z-index: 20;
    min-height: var(--header-height);
    background: rgba(8, 15, 27, 0.96);
    border-bottom: 1px solid var(--line);
    backdrop-filter: blur(14px);
`;

const Inner = styled.div`
    width: min(100%, 1180px);
    min-height: var(--header-height);
    margin: 0 auto;
    padding: 0 16px;
    display: flex;
    align-items: center;
    gap: 14px;

    @media (min-width: 768px) {
        padding: 0 28px;
        gap: 24px;
    }
`;

const Brand = styled(Link)`
    min-width: 0;
    margin-right: auto;
    color: var(--text);
    font-family: Georgia, "Times New Roman", serif;
    font-size: clamp(19px, 5.2vw, 28px);
    font-weight: 700;
    line-height: 1;
    letter-spacing: -0.04em;
    white-space: nowrap;

    span {
        color: var(--accent);
    }

    &:hover {
        color: var(--text);
    }
`;

const Soulara = styled.a`
    min-height: 44px;
    display: inline-flex;
    align-items: center;
    color: var(--text);
    font-size: 14px;
    font-weight: 650;
    white-space: nowrap;

    &:hover {
        color: var(--accent);
    }
`;

const MenuWrap = styled.div`
    position: relative;
`;

const MenuButton = styled.button`
    min-width: 48px;
    min-height: 44px;
    padding: 0 13px;
    border: 1px solid var(--line-strong);
    border-radius: 999px;
    background: var(--surface);
    color: var(--text);
    font: inherit;
    font-weight: 650;
    cursor: pointer;

    &:hover,
    &[aria-expanded="true"] {
        border-color: var(--accent);
        background: var(--surface-raised);
    }
`;

const Menu = styled.div`
    position: absolute;
    top: calc(100% + 10px);
    right: 0;
    width: min(290px, calc(100vw - 24px));
    padding: 10px;
    background: #121c2d;
    border: 1px solid var(--line-strong);
    border-radius: 16px;
    box-shadow: var(--shadow-lg);

    .menu-label {
        padding: 8px 10px 6px;
        color: var(--muted);
        font-size: 11px;
        font-weight: 750;
        letter-spacing: 0.12em;
        text-transform: uppercase;
    }

    a,
    .menu-action {
        width: 100%;
        min-height: 44px;
        padding: 10px;
        display: flex;
        align-items: center;
        border-radius: 9px;
        color: var(--text-soft);
        font-size: 14px;
        font-weight: 600;
    }

    a:hover,
    .menu-action:hover {
        color: var(--text);
        background: var(--surface-raised);
    }

    .menu-divider {
        height: 1px;
        margin: 8px 4px;
        background: var(--line);
    }
`;

const SiteHeader = ({ user }) => {
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef(null);

    useEffect(() => {
        if (!isOpen) return undefined;

        const closeOnClick = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) setIsOpen(false);
        };
        const closeOnEscape = (event) => {
            if (event.key === "Escape") setIsOpen(false);
        };

        document.addEventListener("mousedown", closeOnClick);
        document.addEventListener("keydown", closeOnEscape);
        return () => {
            document.removeEventListener("mousedown", closeOnClick);
            document.removeEventListener("keydown", closeOnEscape);
        };
    }, [isOpen]);

    return (
        <Header>
            <Inner>
                <Brand to="/" aria-label="Sex Chat Dating home">
                    Sex Chat <span>Dating</span>
                </Brand>
                <Soulara href="https://getsoulara.com/" target="_blank" rel="noreferrer">
                    Soulara ↗
                </Soulara>
                <MenuWrap ref={ menuRef }>
                    <MenuButton
                        type="button"
                        aria-expanded={ isOpen }
                        aria-controls="site-menu"
                        onClick={ () => setIsOpen((open) => !open) }
                    >
                        Menu
                    </MenuButton>
                    { isOpen && (
                        <Menu id="site-menu" role="menu">
                            { user && (
                                <>
                                    <div className="menu-label">Account</div>
                                    <Link to="/profile" role="menuitem" onClick={ () => setIsOpen(false) }>My profile</Link>
                                    { (user.role === "admin" || user.role === "moderator") && (
                                        <Link to="/admin" role="menuitem" onClick={ () => setIsOpen(false) }>Admin panel</Link>
                                    ) }
                                    <LogOut className="menu-action"/>
                                    <div className="menu-divider"/>
                                </>
                            ) }
                            <div className="menu-label">Our network</div>
                            { NETWORK_LINKS.map(([label, href]) => (
                                <a key={ href } href={ href } target="_blank" rel="noreferrer" role="menuitem">
                                    { label } ↗
                                </a>
                            )) }
                        </Menu>
                    ) }
                </MenuWrap>
            </Inner>
        </Header>
    );
};

export default SiteHeader;
